import React from 'react';
import { Button, Tag as CustomTag } from 'antd';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { EntityType, RecommendationContent, Tag } from '../../../../types.generated';
import { UnionType } from '../../../search/utils/constants';
import { navigateToSearchUrl } from '../../../search/utils/navigateToSearchUrl';
import { useEntityRegistry } from '../../../useEntityRegistry';

const TagSearchListContainer = styled.div`
    gap: 4px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

type Props = {
    content: Array<RecommendationContent>;
    onClick?: (index: number) => void;
};

export const TagSearchList = ({ content, onClick }: Props) => {
    const history = useHistory();
    const entityRegistry = useEntityRegistry();

    const tags: Array<Tag> = content
        .map((cnt) => cnt.entity)
        .filter((entity) => entity !== null && entity !== undefined)
        .map((entity) => entity as Tag);

    const onClickTag = (tag: any, index: number) => {
        onClick?.(index);
        navigateToSearchUrl({
            filters: [
                {
                    field: 'tags',
                    values: [tag.urn],
                },
                {
                    field: 'fieldTags',
                    values: [tag.urn],
                },
            ],
            history,
            unionType: UnionType.OR,
        });
    };

    return (
        <TagSearchListContainer>
            {tags.map((tag, index) => (
                <Button type="link" className="f-tag-list-btn" key={tag.urn} onClick={() => onClickTag(tag, index)}>
                    <CustomTag
                        closable={false}
                        className="label-tag base-tag f-outlined ma-0"
                        title={entityRegistry.getDisplayName(EntityType.Tag, tag)}
                    >
                        <span>{entityRegistry.getDisplayName(EntityType.Tag, tag)}</span>
                    </CustomTag>
                </Button>
            ))}
        </TagSearchListContainer>
    );
};
